import { render, staticRenderFns } from "./InfoSaveBtn.vue?vue&type=template&id=1f8d888e"
import script from "./InfoSaveBtn.vue?vue&type=script&lang=js"
export * from "./InfoSaveBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports